var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Cornerstone',{attrs:{"path":_vm.path,"download":true},on:{"loaded":_vm.loaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }